var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);

  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

var __markAsModule = target => __defProp(target, "__esModule", {
  value: true
});

var __objRest = (source, exclude) => {
  var target = {};

  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];

  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

var __export = (target, all) => {
  __markAsModule(target);

  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2)) if (!__hasOwnProp.call(target, key) && key !== "default") __defProp(target, key, {
      get: () => module2[key],
      enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable
    });
  }

  return target;
};

var __toModule = module2 => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? {
    get: () => module2.default,
    enumerable: true
  } : {
    value: module2,
    enumerable: true
  })), module2);
};

__export(exports, {
  default: () => Primary_default
});

var import_react3 = __toModule(require("@linaria/react"));

var import_showroom_css_theme2 = __toModule(require("@carvana/showroom-css-theme"));

var import_react2 = __toModule(require("react"));

var import_core = __toModule(require("@linaria/core"));

var import_react = __toModule(require("@linaria/react"));

var import_showroom_css_theme = __toModule(require("@carvana/showroom-css-theme"));

var DefaultButton = (0, import_react.styled)("button")({
  name: "DefaultButton",
  class: "d14aom7e"
});
var Button = (0, import_react2.forwardRef)((_a, ref) => {
  var _b = _a,
      {
    size = "large",
    testId = "Button",
    className = "",
    mode,
    children,
    type = "button"
  } = _b,
      restProps = __objRest(_b, ["size", "testId", "className", "mode", "children", "type"]);

  return import_react2.default.createElement(DefaultButton, __spreadValues({
    ref,
    "data-testid": testId,
    className: (0, import_core.cx)(className, mode + "-mode", size + "-size"),
    type
  }, restProps), children);
});
var Button_default = Button;
var Base_default = Button_default;
var Primary_default = (0, import_react3.styled)(Base_default)({
  name: "Primary0",
  class: "p1234149"
});